import React, { useState } from "react";
import { NavLink, useNavigate, Link } from 'react-router-dom'
import { Image, Button } from 'react-bootstrap';
import userIcon from "../assets/img/user.png"
import logoImage from "../assets/img/logo.png"
import { Spin as Hamburger } from 'hamburger-react'
import { Avatar } from "antd";


function Sidebar({ routes, toggle, toggleHandler1 }) {
  const [name, setName] = useState(localStorage.getItem("user_namefamily"));
  const [image, setImage] = useState(localStorage.getItem("user_profile"));
  const navigate = useNavigate();


  const exitHandler = (e) => {
    localStorage.removeItem('UserId');
    localStorage.clear();
    localStorage.setItem("isLoggedOut", "true"); // تنظیم فلگ خروج
    window.location.replace("https://ssokeshvar.moi.ir/logout")
    // navigate('https://ssokeshvar.moi.ir/logout');
  }


  return (
    <div className="rgc-main-side">


      <div className={toggle ? "l-navbar rgc-show" : "l-navbar"} id="nav-bar">
        <nav className="nav">
          <div>
            <div className="header_toggle d-none d-lg-block">
              <Hamburger
                toggled={toggle}
                toggle={toggleHandler1}
                size={27}
                rounded={true}
              />
              {/* <i
                onClick={toggleHandler}
                className="fa fa-bars"
                aria-hidden="true"
                id="header-toggle"
              ></i> */}
            </div>

            <div className="d-block d-lg-none">
              <NavLink to="../profile" aria-current="page">
                <div className="d-flex flex-column nav_logo justify-content-start rgc-txt-profile">
                  <Avatar
                    className="fa fa-user-circle rgc-avatar"
                    size="large"
                    src={image}
                  />
                  <div>{name}</div>
                </div>
              </NavLink>
              <hr className="m-3"/>
            </div>
           
            {/* <div className="d-flex flex-column rgc-txt-profile nav_logo d-block d-lg-none">
                <Image src={logoImage} />
                <span>اپلیکیشن آمل من</span>
              </div>
              <div>{name}</div>       
            <Avatar
                  className="fa fa-user-circle rgc-avatar"
                  size="large"
                  src={image}
                />
                </div> */}
        
            <div className="nav_list">
              {routes.map((prop, key) => {
                if (!prop.redirect && prop.layout === "menu")
                  return (

                    <li key={key} onClick={toggleHandler1}>
                      <NavLink
                        to={prop.path}
                        className="nav_link active"
                        onClick={toggleHandler1}
                      >
                        <i className={prop.icon} />
                        <span className="nav_name">{prop.name}</span>
                      </NavLink>
                    </li>
                  );
                return null;
              })}

              <div
                className="nav_link"
                onClick={(e) => exitHandler(e)}
              >
                <i className="fas fa-power-off fa-fw  nav_icon"></i>
                <span className="nav_name">خروج</span>
              </div>
            </div>


          </div>
        </nav>
      </div>
    </div>

  );
}

export default Sidebar;
